import { vnAppZone } from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone";
import { vn_app_zone_notification } from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";

import {
    XMLHttpRequestHandler,
    XMLHttpRequestHandler_requestType
} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { transactionsDelete_template } from "../components/templates/transactionsDelete_template";
import { validationsList_template } from "../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/validationsList_template";
import { header } from "./header";

declare var ko: any;
declare var page: any;
declare var Dropzone: any;

export class transactions_delete extends vnModule_knockoutJS{

    protected XHRHdl: XMLHttpRequestHandler;
    protected editForm: transactionsDelete_template;
    protected validationsList: validationsList_template;

    protected getModuleName(){
        return "transactions_delete";
    }

    buildContent() : Array<Element>{

        // create validation errors list template
        this.validationsList = new validationsList_template("validationList", this.viewModel, this);

        // create the transactions form
        this.editForm = new transactionsDelete_template("editForm", this.viewModel, this);

        return [this.validationsList.build(), this.editForm.build()];
    }

    fillPage() : void{
        this.editForm.buildDatePickerCalendar();

        this.getFormData();
    }

    protected saveEditTransaction(){

        this.save();
    }

    protected cancelEditTransaction(){

        this.releaseLock();

        // redirect ot user list
        this.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_WARNING, "Transaction action canceled!");
        this.getVnAppZone().showNotificationToModule();

        let idBrand = this.getTransactionSystem();
        let url = '/brand/' + idBrand + '/payment/transactions/';
        if (idBrand == 'VN') {
            url = '/payment/transactions/'
        }
        page.redirect(url);

    }

    protected releaseLock(){

        // request a lock release
        let idBrand = this.getTransactionSystem();
        let usrReq_url: string = '/api/brand/' + idBrand + '/payment/transaction/release/lock_reverse';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", this.getVnAppZone().app.params.id] );
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.execute();
    }

    //
    // obtain the dynamic data required to fill the formulary
    protected getFormData(){

        this.loadingIn(this.editForm.builtTemplate);

        let id: number;
        let action: string;

        if( (id = this.getVnAppZone().app.params.id) && !isNaN(id)) {
            this.viewModel["editForm"].id(id);
        }

        let usrReq_url: string;
        let idBrand = this.getTransactionSystem();
        usrReq_url = '/api/brand/' + idBrand + '/payment/transaction/delete/form/data';

        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push( ["data", ko.toJSON(this.viewModel["editForm"])] );
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetFormDataReturn;
        this.XHRHdl.execute();
    }
    //
    // use the form data to fill the form
    protected onGetFormDataReturn(req, obj){

        return function(){
            if (req.request.readyState == 4) {

                let thisModule = (<transactions_delete>obj);
                let responseParsed = JSON.parse(req.request.response);
                let idBrand = obj.getTransactionSystem();
                let url: string = '/brand/' + idBrand + '/payment/transactions/';
                if (idBrand == 'VN') {
                    url = '/payment/transactions/';
                }

                if(  req.request.status == 200  ){

                    let vnApp = thisModule.getVnAppZone().app;
                    let data = responseParsed.data;
                    let trx = data.transaction;
                    let reverseTrx = data.reverseTransaction;

                    //if paid and not a reversal, show the reversal transaction
                    if (trx.status.id == 2 && trx.actionType.id == 1){
                        obj.editForm.showReversalTrx();
                    }
                    obj.editForm.setComparisonTransactions(trx, reverseTrx, data);
                    obj.editForm.showComparisonTrx();
                    //obj.editForm.setReverseTrxData(data);

                    obj.loadingOut(obj.editForm.builtTemplate);
                    obj.validationsList.clearMessages();
                }
                else{
                    if( req.request.status == "423" ){
                        obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_WARNING, responseParsed.message);
                        obj.getVnAppZone().showNotificationToModule();
                    }
                    else{
                        let msg = "error: while obtaining the form data - (" + req.request.status +")";
                        obj.validationsList.setSingleMessage({field: "error", "label": req.request.status, message: msg});
                        window.scrollTo(0, 0);
                    }
                    page.redirect(url);

                }
            }
        }
    }

    protected save(){

        let _this = this;
        let idBrand = this.getTransactionSystem();
        let formReq_url: string = '/api/brand/' + idBrand + '/payment/transaction/delete';
        let formReq_params: Array<Array<string>> = [];

        let id: number;

        if( (id = this.getVnAppZone().app.params.id) && !isNaN(id)) {
            this.viewModel["editForm"].id(id);
        }

        formReq_params.push( ["data", ko.toJSON(this.viewModel["editForm"])] );

        let XHRHdl:XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url,formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = (function(req, obj){

            return function() {

                if (req.request.readyState == 4) {

                    let accountsEditModule = (<transactions_delete>obj);
                    let responseParsed = JSON.parse(req.request.response);

                    if(  req.request.status == 200  ){
                        obj.releaseLock();

                        obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, "Transaction deleted successfully!");
                        obj.getVnAppZone().showNotificationToModule();
                        obj.validationsList.clearMessages();

                        let idBrand = obj.getTransactionSystem();
                        let url = '/brand/' + idBrand + '/payment/transactions/';
                        if (idBrand == 'VN') {
                            url = '/payment/transactions';
                        }

                        page.redirect(url);
                    }
                    else{
                        if( responseParsed.type == "error_validation" ){
                            obj.validationsList.setMessages(responseParsed.validations);
                            window.scrollTo(0, 0);
                        }
                        else{
                            let msg = responseParsed.message;
                            obj.validationsList.setSingleMessage({field: "error", "label": req.request.status, message: msg});
                            window.scrollTo(0, 0);
                        }
                    }
                }
            }
        });
        XHRHdl.execute();
    }


    protected getTransactionSystem() {

        let idBrand = this.getVnAppZone().app.params.idBrand;
        if (idBrand == undefined || idBrand == 'undefined') {
            idBrand = 'VN';
        }
        return idBrand;
    }

}



// WEBPACK FOOTER //
// ./js/modules/transactions_delete.ts